// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadConfiguration_container__2huKk","isLoading":"LoadConfiguration_isLoading__18Abo"};